module.exports = __webpack_public_path__ + "img/phone-icon.f1b32623.svg";